<render-component [pageComponents]=contactContent.page_components></render-component>
